var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.form_data)?_c('div',[_c('recharge-wallet',{attrs:{"form_data":_vm.form_data,"recharge_wallet":_vm.recharge_wallet}}),(_vm.$can('update-info', 'card-to-card-gateway')
           )?_c('update-wallet-settings',{attrs:{"form_data":_vm.form_data,"submit_card_to_card_settings":_vm.submit_card_to_card_settings}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }